import accuracyMap from 'helpers/presentation/accuracyMap'
import fovModeHelper from 'helpers/fovModeHelper'

/** Used in tests and to initialize state */
export default function initialPresentationValues(camera) {
  const values = {}

  for (let [attrName, accValue] of accuracyMap()) {
    if (attrName === 'angleOfView') {
      values[attrName] = {
        value: camera[`${fovModeHelper(camera.fovMode)}AngleOfView`].toFixed(accValue),
        touched: false
      }
      continue
    }

    if (attrName === 'fieldOfView') {
      values[attrName] = {
        value: camera[`${fovModeHelper(camera.fovMode)}FieldOfView`].toFixed(accValue),
        touched: false
      }
      continue
    }

    values[attrName] = {
      value: camera[attrName].toFixed(accValue),
      touched: false
    }
  }
  return values
}



// WEBPACK FOOTER //
// ./src/helpers/presentation/initialPresentationValues.js